import { render, staticRenderFns } from "./Occupations.vue?vue&type=template&id=72876384&"
import script from "./Occupations.vue?vue&type=script&lang=js&"
export * from "./Occupations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports